export default "__VITE_ASSET__BjjWcy7N__"